package com.eladfinish.bible.contest.ui.components.toolbar.ui

import androidx.compose.foundation.layout.widthIn
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material3.DropdownMenu
import androidx.compose.material3.MenuDefaults
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.unit.dp
import com.eladfinish.bible.contest.SharedRes
import com.eladfinish.bible.contest.menu_background_color
import dev.icerock.moko.resources.compose.colorResource

@Composable
internal fun ThemedOverflowMenu(
    expanded: Boolean,
    onDismissRequest: () -> Unit,
    modifier: Modifier = Modifier,
    content: @Composable () -> Unit,
) {
    DropdownMenu(
        expanded = expanded,
        onDismissRequest = onDismissRequest,
        modifier = modifier.widthIn(min = 200.dp),
        shape = RoundedCornerShape(16.dp),
        containerColor = colorResource(SharedRes.colors.menu_background_color),
        tonalElevation = 0.dp,
        shadowElevation = 6.dp,
    ) {
        content()
    }
}

@Composable
internal fun menuItemColors() = MenuDefaults.itemColors(
    textColor = Color.White,
    leadingIconColor = Color.White,
    trailingIconColor = Color.White,
    disabledTextColor = Color.White.copy(alpha = 0.38f),
    disabledLeadingIconColor = Color.White.copy(alpha = 0.38f),
    disabledTrailingIconColor = Color.White.copy(alpha = 0.38f),
)
